

import { onUnmounted, ref } from '@vue/composition-api'
import {FilterServices} from './services'

export default function filter(type) {


  const ownersOptions = ref([])
  const contractsOptions = ref([])
  const areasContractsOptions_orig=ref([])
  const categoriesOptions = ref([])
  const typesOptions = ref([])
  const typesOptions_orig=ref([])



  FilterServices.getFilterOptionsBy(type)
  
    .then(response => {
      const { 
      categories, groups, contracts, owners, managers, roles, types } = response.data.data
      ownersOptions.value = owners
      contractsOptions.value = contracts
      areasContractsOptions_orig.value=JSON.parse(JSON.stringify(contracts));
      categoriesOptions.value = categories
      typesOptions.value = types
      typesOptions_orig.value=types




    })


  return {
    ownersOptions,
    typesOptions,
    typesOptions_orig,
    categoriesOptions,
    contractsOptions,
    areasContractsOptions_orig



  }

}
